import { Injectable } from '@angular/core';
import { CookieService } from './cookie.service';
import { Difficulty } from './question.service';
import UiTextsJson from 'src/assets/datas/UI_texts.json';
import AriaTextsJson from 'src/assets/datas/ARIA_texts.json';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  public uiLanguage: Language;
  public learnLanguage: Language;
  public learnDifficulty: Difficulty;

  public UiTexts: { [id: string]: Translation; };
  public AriaTexts: { [id: string]: Translation; };

  constructor(private cookieService: CookieService) {
    // for (const option of UiTextsJson){
    this.UiTexts = UiTextsJson;
    this.AriaTexts = AriaTextsJson;
    // }
  }

  public CheckRelevantCookieData(): void {

    if (!this.learnLanguage) {
      this.learnLanguage = this.cookieService.GetCookieValue('learnLanguage') as Language;
      if (!this.learnLanguage) {
        this.learnLanguage = Language.ENG;
      }
    }

    if (!this.uiLanguage) {
      this.uiLanguage = this.cookieService.GetCookieValue('uiLanguage') as Language;
      if (!this.uiLanguage) {
        this.uiLanguage = Language.FIN;
      }
    }

    if (!this.learnDifficulty) {
      let difficulty = this.cookieService.GetCookieValue('difficulty') as Difficulty;
      if (!difficulty) {
        difficulty = Difficulty.Easy;
      }
      this.learnDifficulty = difficulty;
    }
  }

  public SaveCurrentValues(): void {
    this.cookieService.SetCookieValue('uiLanguage', this.uiLanguage);
    this.cookieService.SetCookieValue('learnLanguage', this.learnLanguage);
  }

}

export enum Language {
  UNDEFINED = 'undef',
  FIN = 'fi',
  SWE = 'sw',
  ENG = 'en'
}

export class Translation {

  public fi: string;
  public sw: string;
  public en: string;

  constructor(json?: any){
    if (!!json) {
      this.fi = json.fi;
      this.sw = json.sw;
      this.en = json.en;
    }
  }

}


